export const getTomorrowsDate = () => {
    const today = new Date();
    return new Date(today.setDate(today.getDate() + 1));
};